import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import { updateMultiplier } from '../../../../stores/algos-list/actions';
import FlatNumericInput from '../../../../components/Basic/FlatNumericInput';
import { addNotification } from '../../../../actions/notifications';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&.isValueUpadted': {
      '& .MuiInputBase-input': {
        color: 'var(--color-colorPrimary-main)',
        borderColor: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const CellMultiplier = ({ row = {} }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { original = {} } = row;
  const { _id = '' } = original;
  const isTradeActive = useSelector((state) => {
    const { status = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return status === 'TRADE_ACTIVE' ? true : false;
  });

  const multiplier = useSelector((state) => {
    const { multiplier = 1 } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return multiplier;
  });

  const multiplierLoading = useSelector((state) => {
    const { multiplierLoading = false } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return multiplierLoading;
  });

  const [value, setValue] = useState(multiplier);

  const isValueUpadted = value !== multiplier;

  const handleValueChange = (val) => {
    setValue(val);
  };

  const handleMultiplierSave = async () => {
    try {
      if (!isValueUpadted) {
        return;
      }

      const { isSuccess = false } = await dispatch(
        updateMultiplier(_id, value)
      );

      if (isSuccess) {
        dispatch(
          addNotification({
            type: 'success',
            message: `Algo Multiplier updated successfully`,
          })
        );
      }
    } catch (err) {
      setValue(multiplier);

      if (err && err.message && err.message === 'Network Error') {
        dispatch(
          addNotification({
            type: 'error',
            message: 'Algo Multiplier update failed',
          })
        );
      }
    }
  };

  useEffect(() => {
    setValue(multiplier);
  }, [multiplier]);

  return (
    <div
      className={`${classes.root} ${
        isValueUpadted && !multiplierLoading ? 'isValueUpadted' : ''
      }`}
    >
      <FlatNumericInput
        value={value}
        onChange={handleValueChange}
        onBlur={handleMultiplierSave}
        disabled={multiplierLoading || isTradeActive}
        suffix="x"
      />
    </div>
  );
};

export default CellMultiplier;
